import React from "react";
import { Login } from "../screens";


const publicRoutes = [
  { path: "/", element: <Login /> }
];

export default publicRoutes;